import type { SVGProps } from "react";
const SvgAdd = (props: SVGProps<SVGSVGElement>) => <svg viewBox="0 0 32 32" width="1em" height="1em" {...props}><path d="M17 6a1 1 0 1 0-2 0v9H6a1 1 0 1 0 0 2h9v9a1 1 0 1 0 2 0v-9h9a1 1 0 1 0 0-2h-9z" /></svg>;
export default SvgAdd;